import React, { forwardRef } from "react";
import IconBase, { IconProps } from "./icon-base";

const AspectRatio = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  return (
    <IconBase
      ref={ref}
      renderPath={() => {
        return (
          <svg width="24" height="21" viewBox="0 0 28 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M22.7054 20.0001H7.09802V6.05469H17.2878L22.7054 11.3934V20.0001Z"
              stroke="white"
              strokeWidth="1.5"
              strokeMiterlimit="10"
            />
            <path d="M17.2878 6.05469V11.4648L22.7055 11.3934" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" />
            <path d="M7.09802 0V4.25911" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" />
            <path d="M0.948486 6.05469H5.27812" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" />
          </svg>
        );
      }}
      {...props}
    >
      {props.children}
    </IconBase>
  );
});

AspectRatio.displayName = "AspectRatio";

export { AspectRatio };
